import groq from "groq";
import { Author, authorFields } from "./author";
import { FilterOption } from "./filterManager";
import type * as Schema from "./schema";

export type Article<
  T extends Schema.SanityDocument & Omit<Schema.Article, "_type">,
> = Pick<
  T,
  | "_id"
  | "slug"
  | "title"
  | "primaryImage"
  | "lede"
  | "body"
  | "audience"
  | "readTime"
> & {
  publishedAt: string;
  updatedAt: string;
  category: T extends { _type: string } ? T["_type"] : never; // use sanity document _type as discriminator
  author?: Author;
  audienceData: Array<
    FilterOption & {
      icon: null | Schema.AudienceIcon["icon"];
    }
  >;
};

export const publishedAtExpression = groq`coalesce(publishedAt, _updatedAt)`;

export const articleFields = groq`
  _id,
  slug,
  title, 
  primaryImage,
  lede,
  body,
  audience,
  "audienceData": audience[]->{
    value,
    displayName,
    // there cannot be more than one audienceIcon per audience type
    "icon": *[_type == "audienceIcon" && references(^._id)][0].icon
  },
  readTime,
  seo,
  "publishedAt": ${publishedAtExpression},
  "updatedAt": _updatedAt,
  "category": _type,
  "author": author->{${authorFields}}
`;
